import { forwardRef } from "react";
import InputError from "../Error";
import styles from "../Form.module.css";

export interface TextareaProps
  extends React.DetailedHTMLProps<
    React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  > {
  label?: string;
  error?: string;
  srOnlyLabel?: boolean;
}
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (props, ref) => {
    const { label, error, srOnlyLabel, ...rest } = props;
    const { id } = rest;
    return (
      <div>
        <label htmlFor={id} className={srOnlyLabel ? "sr-only" : ""}>
          {label}
        </label>
        <textarea
          {...rest}
          ref={ref}
          className={`p-2 shadow-sm block w-full sm:text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primaryColor-normal ${
            error ? styles["form-input-error"] : styles["form-input-normal"]
          }`}
        />
        {error && <InputError>{error}</InputError>}
      </div>
    );
  }
);
